import { FixedEditorLayout } from "components/modules/Layout/FixedEditorLayout/FixedEditorLayout";
import { EditorNavbar } from "components/modules/Navigation/EditorNavbar/EditorNavbar";
import { useRouter } from "next/router";
import { BottomMenu } from "./BottomMenu/BottomMenu";
import { EditSettings } from "./EditSettings/EditSettings";
import { Preview } from "./Preview/Preview";
import { PreviewList } from "./Preview/PreviewList/PreviewList";
import { useCompressor } from "components/modules/Editors/Compressor/useCompressor";
import { usePreview } from "components/modules/Editors/Compressor/Preview/usePreview";
import { InvalidImageExtensionModal } from "components/modules/Uploader/InvalidImageExtensionModal/InvalidImageExtensionModal";
import { getQueryClient } from "@/lib/queryClient";
import { QueryClientProvider } from "@/contexts/QueryClientProvider";

export interface ICompressorProps {
    toolPathName: string;
}

export const Compressor = ({ toolPathName }: ICompressorProps) => {
    const { pathname } = useRouter();
    useCompressor(toolPathName);
    const { shouldApplyVerticalOptimizationForSmallScreen } = usePreview();
    const client = getQueryClient();
    return (
        <QueryClientProvider client={client}>
            <FixedEditorLayout
                config={{
                    hideBottomAd: shouldApplyVerticalOptimizationForSmallScreen,
                }}
                navbar={<EditorNavbar actionButton={null} url={pathname as any} />}
                leftBar={<Preview />}
                preview={
                    <div className="grid h-full max-h-full lg:overflow-y-hidden">
                        <div className="hidden overflow-x-hidden lg:block">
                            <EditSettings />
                        </div>
                        <div className="h-full pt-2 lg:hidden">
                            <PreviewList />
                        </div>
                    </div>
                }
                bottomMenu={<BottomMenu />}
            />
            <InvalidImageExtensionModal />
        </QueryClientProvider>
    );
};
